<template>
  <div>
    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('users')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Usuarios</div>
      </inertia-link>
    </div>
   <!-- <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('contacts')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('contacts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Clientes</div>
      </inertia-link>
    </div>-->
    <div  class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('cotizadors')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('cotizadors') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('cotizadors') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Cotizador</div>
      </inertia-link>
    </div>
    <div v-if="$page.props.auth.user.rol =='Admin'" class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('proyectos')">
        <icon name="cheveron-right" class="w-4 h-4 mr-2" :class="isUrl('proyectos') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('proyectos') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Proyectos</div>
      </inertia-link>
    </div>
  
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import DropdownMenu from '@innologica/vue-dropdown-menu'

export default {
  components: {
    Icon,
    DropdownMenu
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
